module.exports = __webpack_public_path__ + "static/media/icon_eventos_asesoria.ba5fe55f.svg";